/* @flow */

import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './Heading.style';
import { createBaseUiComponentProps } from 'src/shared/ui/base/util/uiUtils';

import type { BaseUiComponent } from 'src/shared/ui/base/type/uiTypes';

type Props = {
  ...BaseUiComponent,
  children: React.Node,
};

const useStyles = createUseThemeStyles(styles);

const Heading = (props: Props): React.Node => {
  const classes = useStyles();

  return (
    <h1 {...createBaseUiComponentProps(props, classes.root)}>
      {props.children}
    </h1>
  );
};

export default React.memo<Props>(Heading);
